export class MovementOffsetDTO {
  value: number;
  direction: boolean;
  constructor(value: number, direction: boolean) {
    this.value = value;
    this.direction = direction;
  }
}
